/** Ray-casting point-in-polygon test. Points are [x, y] normalized 0-1. */
export function pointInPolygon(
  px: number,
  py: number,
  polygon: number[][],
): boolean {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0],
      yi = polygon[i][1];
    const xj = polygon[j][0],
      yj = polygon[j][1];

    const intersect =
      yi > py !== yj > py && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

/** Given a box's points, return the aisle index whose detection region contains the box center.
 *  Falls back to 0 if no aisle matches. */
export function getAisleIndexForBox(
  boxPoints: number[][],
  aisleDetections: { points: number[][] }[],
): number {
  if (aisleDetections.length === 0) return 0;

  // Compute box center
  const cx =
    boxPoints.reduce((sum, p) => sum + p[0], 0) / boxPoints.length;
  const cy =
    boxPoints.reduce((sum, p) => sum + p[1], 0) / boxPoints.length;

  for (let i = 0; i < aisleDetections.length; i++) {
    if (pointInPolygon(cx, cy, aisleDetections[i].points)) {
      return i;
    }
  }

  // Fallback: nearest aisle by centroid distance
  let bestIndex = 0;
  let bestDist = Infinity;
  for (let i = 0; i < aisleDetections.length; i++) {
    const pts = aisleDetections[i].points;
    const ax = pts.reduce((s, p) => s + p[0], 0) / pts.length;
    const ay = pts.reduce((s, p) => s + p[1], 0) / pts.length;
    const dist = (cx - ax) ** 2 + (cy - ay) ** 2;
    if (dist < bestDist) {
      bestDist = dist;
      bestIndex = i;
    }
  }
  return bestIndex;
}
